<template>
  <b-modal
      id="asignar-orden-modal"
      title="Asignar Orden de Trabajo"
      hide-footer
      size="lg"
      header-bg-variant="warning"
      header-text-variant="dark"
    >
      <!-- Contenido -->
      <h6 class="fw-bold mb-3">Grupal</h6>

      <div class="d-flex flex-wrap gap-2 p-3 bg-light rounded">
        <b-button
          v-for="(item, index) in opciones"
          :key="index"
            :variant="opcionesSelecteds.some(selected => selected.id === item.id) ? 'success' : 'btn-secondary'"
          class="px-3 mr-2"
          @click="seleccionar(item)"
        >
          {{ item.nombre }}
        </b-button>
      </div>

      <!-- Footer personalizado -->
      <div class="d-flex justify-content-end mt-4">
        <b-button variant="secondary" class="me-2 mr-2"
          @click="$bvModal.hide('asignar-orden-modal')">
          Cancelar
        </b-button>
        <b-button variant="success" class="mr-2" @click="guardar">
          Guardar
        </b-button>
      </div>
    </b-modal>
</template>

<script>
import { util } from '@/plugins/util';
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import axios from '@/modules/common/axiosERP';

export default {
  name: 'TheModalAsignacionOT',
  props: {
    itemInsumo: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
    };
  },
  created() {},
  methods: {
    seleccionar(item) {
      const index = this.opcionesSelecteds.findIndex((i) => i.id === item.id);
      if (index !== -1) {
        this.opcionesSelecteds.splice(index, 1);
      } else {
        this.opcionesSelecteds.push(item);
      }
    },
    async guardar() {
      try {
        const PARAMS = {
          insumo_id: this.itemInsumo.id,
          detalles: this.opcionesSelecteds,
        };
        const response = await axios.post('/clinic/servicio_complementario/asignacion', PARAMS);
        util.showNotify(response.data.message, 'success');
        this.$emit('guardarAsignacion', true);
        this.$bvModal.hide('asignar-orden-modal');
        return true;
      } catch (error) {
        const FALLO_VALIDACION = 422;
        if (error.response.status !== FALLO_VALIDACION) {
          util.showNotify(error.response.data.message, 'error');
        } else {
          Object.entries(error.response.data.data).forEach(([, mensajes]) => {
            mensajes.forEach((texto) => util.showNotify(texto, 'error'));
          });
        }
        return false;
      }
    },
  },
  computed: {
    ...mapState('theModalAsignacionOT', [
      'opciones',
    ]),
    ...mapFields('theModalAsignacionOT', [
      'opcionesSelecteds',
    ]),
  },
};
</script>

<style scoped>
/* Para mantener tamaño uniforme de los botones */
button.btn {
  min-width: 130px;
}
</style>
